(function(){
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function reveal(root){
    var els = (root||document).querySelectorAll('.zfs-reveal:not(.is-in)');
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function(e){e.classList.add('is-in')}); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('is-in'); io.unobserve(en.target);} });
    }, {rootMargin:'0px 0px -8% 0px', threshold:0.08});
    els.forEach(function(e){ io.observe(e); });
  }
  function carousels(root){
    (root||document).querySelectorAll('[data-zfs-carousel]').forEach(function(c){
      if (c.dataset.ready) return; c.dataset.ready = 1;
      var track = c.querySelector('[data-zfs-track]');
      var prev = c.querySelector('[data-zfs-prev]'), next = c.querySelector('[data-zfs-next]');
      if(!track) return;
      function step(){ var it = track.children[0]; return it ? it.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap||24) : 300; }
      function upd(){ if(!prev) return; prev.disabled = track.scrollLeft < 8; next.disabled = track.scrollLeft + track.clientWidth > track.scrollWidth - 8; }
      prev && prev.addEventListener('click', function(){ track.scrollBy({left:-step()*2, behavior: reduce?'auto':'smooth'}); });
      next && next.addEventListener('click', function(){ track.scrollBy({left:step()*2, behavior: reduce?'auto':'smooth'}); });
      track.addEventListener('scroll', upd, {passive:true}); window.addEventListener('resize', upd); upd();
    });
  }
  function packs(root){
    (root||document).querySelectorAll('[data-zfs-packs]').forEach(function(w){
      if (w.dataset.ready) return; w.dataset.ready = 1;
      var input = w.querySelector('input[name="id"]'), btn = w.querySelector('[data-zfs-pack-btn]');
      var price = w.querySelector('[data-zfs-pack-price]'), per = w.querySelector('[data-zfs-pack-per]');
      w.querySelectorAll('input[data-zfs-pack]').forEach(function(r){
        r.addEventListener('change', function(){
          input.value = r.value; price.textContent = r.dataset.price; per.textContent = r.dataset.per;
          var ok = r.dataset.available === 'true';
          btn.disabled = !ok; btn.querySelector('span').textContent = ok ? 'Add to cart' : 'Sold out';
          btn.classList.toggle('zfs-btn--disabled', !ok);
        });
      });
    });
  }
  function sticky(){
    var bar = document.querySelector('[data-zfs-sticky]'); if(!bar || bar.closest('.quick-add-modal')) return;
    if (bar.parentElement !== document.body) document.body.appendChild(bar);
    var target = document.querySelector('.product-form__buttons') || document.querySelector('product-form');
    if(!target || !('IntersectionObserver' in window)) return;
    var footer = document.querySelector('.footer');
    var past = false, nearFoot = false;
    function set(){ bar.classList.toggle('is-on', past && !nearFoot); }
    new IntersectionObserver(function(e){ past = !e[0].isIntersecting && e[0].boundingClientRect.top < 0; set(); }).observe(target);
    if (footer) new IntersectionObserver(function(e){ nearFoot = e[0].isIntersecting; set(); }).observe(footer);
    bar.querySelector('[data-zfs-sticky-btn]').addEventListener('click', function(){
      var b = document.querySelector('.product-form__submit');
      if (b && !b.disabled) { b.click(); } else { target.scrollIntoView({behavior: reduce?'auto':'smooth', block:'center'}); }
    });
  }
  function init(root){ reveal(root); carousels(root); packs(root); }
  if (document.readyState !== 'loading') { init(); sticky(); } else document.addEventListener('DOMContentLoaded', function(){ init(); sticky(); });
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();
